var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Emit, Prop, Watch } from "vue-property-decorator";
import { State } from "vuex-class";
import FileUpload from "~/components/common/file-upload.vue";
import LawsuitFollowKind from "./lawsuit-follow-kind/index";
import { lawsuitItem, lawsuitStatus } from "./lawsuit.config";
import { OutsourceLawsuitService } from "~/services/domain-service/outsource-lawsuit-manage-index.service";
var LawsuitFollow = /** @class */ (function (_super) {
    __extends(LawsuitFollow, _super);
    function LawsuitFollow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.lawsuitStatus = lawsuitStatus;
        // 步骤
        _this.currentStep = {
            active: 0,
            code: '',
        };
        // 步骤条
        _this.steps = [];
        // 当前步骤是否保存过
        _this.isSave = false;
        _this.currentComponent = '';
        _this.saveLoading = false;
        return _this;
    }
    LawsuitFollow.prototype.refreshData = function () { };
    LawsuitFollow.prototype.close = function () { };
    /**
     * 计算当前应该显示的页面
     */
    LawsuitFollow.prototype.currentComp = function () {
        var _this = this;
        var steps = lawsuitItem.find(function (v) { return v.kind === _this.lawsuit.kind; }).steps;
        var step = steps.find(function (v) { return v.active === _this.currentStep.active && v.code === _this.currentStep.code; });
        this.currentComponent = step ? step.comp : '';
    };
    /**
     * 控制按钮的显示
     */
    LawsuitFollow.prototype.isShow = function (btn) {
        var _this = this;
        var items = lawsuitItem.find(function (v) { return v.kind === _this.lawsuit.kind; });
        if (!items)
            return false;
        var steps = items.steps;
        if (!steps)
            return false;
        var butType = this.isView ? 'viewButtons' : 'buttons';
        var buttons = steps.find(function (v) { return v.active === _this.currentStep.active; })[butType];
        if (this.lawsuit.status === lawsuitStatus.end || this.lawsuit.status === lawsuitStatus.take) {
            var filteItem_1 = this.lawsuit.status === lawsuitStatus.end ? 'allot' : 'end';
            var tempButtons = buttons.filter(function (v) { return v !== filteItem_1; });
            return tempButtons.includes(btn);
        }
        return buttons.includes(btn);
    };
    /**
     * 获取当前案件步骤
     */
    LawsuitFollow.prototype.getCourtInfoStep = function (code) {
        var _this = this;
        var params = { id: this.rowData.id, lawerStatus: code };
        this.outsourceLawsuitService.getCourtInfoStep(params).subscribe(function (data) {
            if (!data) {
                _this.isSave = false;
                _this.$nextTick(function () {
                    var comp = _this.$refs['current-comp'];
                    comp.reset();
                });
                return;
            }
            _this.isSave = !!data.lawerStatus;
            if (!code && !_this.isView) {
                var steps = lawsuitItem.find(function (v) { return v.kind === _this.lawsuit.kind; }).steps;
                var step = steps.find(function (v) { return v.code === data.lawerStatus; });
                _this.currentStep = step ? { code: step.code, active: step.active } : { code: steps.find(function (v) { return v.active === 0; }).code, active: 0 };
            }
            _this.$nextTick(function () {
                _this.$refs['current-comp'].revertData(data);
            });
        });
    };
    /**
     * 上一步
     */
    LawsuitFollow.prototype.onPrevious = function () {
        if (this.lawsuit.status !== lawsuitStatus.end && this.lawsuit.status !== lawsuitStatus.take) {
            this.updateSteps();
        }
        var step = this.getStep(this.currentStep.active - 1);
        this.getCourtInfoStep(step.code);
        this.currentStep = { code: step.code, active: this.currentStep.active - 1 };
    };
    /**
     * 保存
     */
    LawsuitFollow.prototype.onSave = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, params, e_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getData()];
                    case 1:
                        data = _a.sent();
                        if (!data)
                            return [2 /*return*/];
                        this.saveLoading = true;
                        params = __assign(__assign({}, data), { caseAssistId: this.rowData.id, lawsuitFollowType: this.lawsuit.kind, lawerStatus: this.currentStep.code });
                        this.outsourceLawsuitService.saveCourtInfo(params).subscribe(function () {
                            _this.isSave = true;
                            // 保存之后更新lawsuitStatus为最新的状态
                            var step = _this.getStepByCode(_this.currentStep.code);
                            var status = _this.getStepByCode(_this.lawsuit.status);
                            if (step.active > status.active) {
                                _this.lawsuit.status = step.code;
                            }
                            _this.saveLoading = false;
                            _this.$message.success("操作成功");
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.saveLoading = true;
                        this.$message.error("操作失败，请重试");
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 下一步/执行终结/参与分配
     */
    LawsuitFollow.prototype.next = function (type) {
        var _this = this;
        if (!this.isView && !this.isSave) {
            this.$message.error("此步骤未保存,请保存之后执行下一步");
            return;
        }
        var steps = lawsuitItem.find(function (v) { return v.kind === _this.lawsuit.kind; }).steps;
        var code;
        if (!type) {
            code = steps.find(function (v) { return v.active === _this.currentStep.active + 1; }).code;
        }
        else {
            var tempStep_1 = type === "TAKE" ? lawsuitStatus.take : lawsuitStatus.end;
            code = steps.find(function (v) { return v.active === _this.currentStep.active + 1 && v.code === tempStep_1; }).code;
        }
        this.getCourtInfoStep(code);
        if (type)
            this.updateSteps(type); // 如果是执行终结/参与分配则更新步骤条
        this.currentStep = { code: code, active: this.currentStep.active + 1 };
    };
    /**
     * 撤诉/结案
     */
    LawsuitFollow.prototype.withdraw = function (status) {
        var _this = this;
        this.outsourceLawsuitService.withdraw({ caseId: this.rowData.id, lawerStatus: status }).subscribe(function (data) { return _this.success(); });
    };
    /**
     * 完成
     */
    LawsuitFollow.prototype.onComplete = function () {
        var _this = this;
        if (!this.isSave) {
            this.$message.error("此步骤未保存,请保存之后再点击完成");
            return;
        }
        this.outsourceLawsuitService.withdraw({ caseId: this.rowData.id, lawerStatus: this.currentStep.code }).subscribe(function (data) { return _this.success(); });
    };
    /**
     * 获取表单数据
     */
    LawsuitFollow.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var currentComp, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentComp = this.$refs["current-comp"];
                        return [4 /*yield*/, currentComp.getData()];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    LawsuitFollow.prototype.success = function () {
        this.$message.success("操作成功");
        this.refreshData();
        this.close();
    };
    /**
     * 弹框打开时页面数据刷新
     */
    LawsuitFollow.prototype.refresh = function (lawerStatus) {
        return __awaiter(this, void 0, void 0, function () {
            var step, type;
            return __generator(this, function (_a) {
                if (this.isView) {
                    step = this.getStep(0);
                    this.getCourtInfoStep(step.code);
                    this.currentStep = { code: step.code, active: step.active };
                }
                else {
                    this.getCourtInfoStep();
                }
                if (lawerStatus === "END")
                    type = "END";
                if (lawerStatus === "TAKE")
                    type = "TAKE";
                this.updateSteps(type);
                return [2 /*return*/];
            });
        });
    };
    /**
     * 计算页面步骤条内容
     */
    LawsuitFollow.prototype.updateSteps = function (type) {
        var _this = this;
        var steps = lawsuitItem.find(function (v) { return v.kind === _this.lawsuit.kind; }).steps;
        if (!type) {
            var tempSteps_1 = [];
            for (var _i = 0, steps_1 = steps; _i < steps_1.length; _i++) {
                var step = steps_1[_i];
                tempSteps_1[step.active] = tempSteps_1[step.active] ? tempSteps_1[step.active] + "/" + step.name : step.name;
            }
            this.steps = tempSteps_1;
            return;
        }
        // 执行终结/参与分配
        var tempStep = type === "END" ? lawsuitStatus.end : lawsuitStatus.take;
        var endStep = steps.find(function (v) { return v.code === tempStep; });
        var tempSteps = [];
        for (var _a = 0, steps_2 = steps; _a < steps_2.length; _a++) {
            var step = steps_2[_a];
            if (step.active !== endStep.active) {
                tempSteps.push(step.name);
            }
            else if (step.code === tempStep) {
                tempSteps.push(step.name);
            }
        }
        this.steps = tempSteps;
    };
    LawsuitFollow.prototype.getStep = function (active) {
        var _this = this;
        var steps = lawsuitItem.find(function (v) { return v.kind === _this.lawsuit.kind; }).steps;
        var step = steps.find(function (v) { return v.active === active; });
        if (!step)
            return {};
        return {
            name: step.name,
            code: step.code,
            active: step.active
        };
    };
    LawsuitFollow.prototype.getStepByCode = function (code) {
        var _this = this;
        var steps = lawsuitItem.find(function (v) { return v.kind === _this.lawsuit.kind; }).steps;
        var step = steps.find(function (v) { return v.code === code; });
        if (!step)
            return {};
        return {
            name: step.name,
            code: step.code,
            active: step.active
        };
    };
    __decorate([
        Dependencies(OutsourceLawsuitService)
    ], LawsuitFollow.prototype, "outsourceLawsuitService", void 0);
    __decorate([
        State
    ], LawsuitFollow.prototype, "userData", void 0);
    __decorate([
        Prop()
    ], LawsuitFollow.prototype, "rowData", void 0);
    __decorate([
        Prop({ default: false })
    ], LawsuitFollow.prototype, "isView", void 0);
    __decorate([
        Prop({
            default: {
                kind: '',
                status: '',
            }
        })
    ], LawsuitFollow.prototype, "lawsuit", void 0);
    __decorate([
        Emit("refreshData")
    ], LawsuitFollow.prototype, "refreshData", null);
    __decorate([
        Emit("close")
    ], LawsuitFollow.prototype, "close", null);
    __decorate([
        Watch("currentStep.active", { deep: true })
    ], LawsuitFollow.prototype, "currentComp", null);
    LawsuitFollow = __decorate([
        Component({
            components: __assign({ FileUpload: FileUpload }, LawsuitFollowKind)
        })
    ], LawsuitFollow);
    return LawsuitFollow;
}(Vue));
export default LawsuitFollow;
